// pageContentService.js - Enhanced version with proper error handling
import axios from 'axios';
import api from './api';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Default content for InfoNieuw page
const defaultInfoNieuwContent = {
  title: "Welkom in Polderzicht",
  titleEn: "Welcome to Polderzicht",
  bodyHtml: "<p>Mijn naam is Gina ter Elst, ik woon op huisnummer 237 en ben voorzitter van de Vereniging van Eigenaren. Namens het hele bestuur wil ik je van harte welkom heten in ons gebouw.</p>",
  bodyHtmlEn: "<p>My name is Gina ter Elst, I live at apartment 237 and I am the chairperson of the Homeowners Association. On behalf of the entire board, I would like to welcome you to our building.</p>"
};

// Get page content from API with improved error handling
const getPageContent = async (pageType) => {
  try {
    console.log(`Fetching content for page type: ${pageType}`);
    const response = await axios.get(`${API_URL}/api/page-content/${pageType}`);
    
    // If we have content from the API, use it
    if (response.data) {
      // Check if content is directly in the response or nested in a content field
      const contentData = response.data.content || response.data;
      console.log("Retrieved content:", contentData); // Debugging
      
      // Return the content data with fallbacks for empty fields
      return {
        title: contentData.title || '',
        titleEn: contentData.titleEn || '',
        bodyHtml: contentData.bodyHtml || '',
        bodyHtmlEn: contentData.bodyHtmlEn || '',
      };
    }
    
    // If no content from API, check localStorage
    const cachedData = localStorage.getItem(`vve_${pageType}_cache`);
    if (cachedData) {
      try {
        return JSON.parse(cachedData);
      } catch (e) {
        console.error("Error parsing cached data:", e);
      }
    }
    
    // Use default content as fallback
    return getDefaultContent(pageType);
  } catch (error) {
    console.error(`Error fetching ${pageType} content:`, error);
    
    // Fall back to localStorage
    const cachedData = localStorage.getItem(`vve_${pageType}_cache`);
    if (cachedData) {
      try {
        return JSON.parse(cachedData);
      } catch (e) {
        console.error("Error parsing cached data:", e);
      }
    }
    
    return getDefaultContent(pageType);
  }
};

// Save page content with improved error handling
const savePageContent = async (pageType, content) => {
  try {
    console.log(`Saving content for ${pageType}:`, content);
    
    // Save to localStorage as backup
    localStorage.setItem(`vve_${pageType}_cache`, JSON.stringify(content));
    console.log('Saved to localStorage');
    
    // Get auth token
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No authentication token found');
      return false;
    }
    
    // Update via API using authenticated request with proper headers
    const response = await api.put(
      `/api/page-content/${pageType}`, 
      content,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    console.log('API response:', response);
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    console.error(`Error saving ${pageType} content:`, error);
    return false;
  }
};

// Get default content
const getDefaultContent = (pageType) => {
  switch (pageType) {
    case 'infonieuw':
      return defaultInfoNieuwContent;
    default:
      return {
        title: '',
        titleEn: '',
        bodyHtml: '',
        bodyHtmlEn: ''
      };
  }
};

export {
  getPageContent,
  savePageContent
};